var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxUnchecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm1-16H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z",
    fill: "#000",
    fillOpacity: 0.87
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDE2SDNDMi40NSAxNiAyIDE1LjU1IDIgMTVWM0MyIDIuNDUgMi40NSAyIDMgMkgxNUMxNS41NSAyIDE2IDIuNDUgMTYgM1YxNUMxNiAxNS41NSAxNS41NSAxNiAxNSAxNlpNMTYgMEgyQzAuOSAwIDAgMC45IDAgMlYxNkMwIDE3LjEgMC45IDE4IDIgMThIMTZDMTcuMSAxOCAxOCAxNy4xIDE4IDE2VjJDMTggMC45IDE3LjEgMCAxNiAwWiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC44NyIvPgo8L3N2Zz4K";
export { SvgCheckboxUnchecked as ReactComponent };